import React from "react";

const BlogFaqFields = ({ values, setFieldValue }) => {
  const faqs = Array.isArray(values.faqs) ? values.faqs : [];

  const updateFaqs = (nextFaqs) => setFieldValue("faqs", nextFaqs);
  const updateFaq = (index, field, value) => {
    const nextFaqs = faqs.map((faq, faqIndex) => (
      faqIndex === index ? { ...faq, [field]: value } : faq
    ));
    updateFaqs(nextFaqs);
  };
  const moveFaq = (index, offset) => {
    const destination = index + offset;
    if (destination < 0 || destination >= faqs.length) return;

    const nextFaqs = [...faqs];
    [nextFaqs[index], nextFaqs[destination]] = [nextFaqs[destination], nextFaqs[index]];
    updateFaqs(nextFaqs);
  };

  return (
    <section className="add_utf_listing_section margin-top-45" aria-labelledby="blog-faq-fields-heading">
      <div className="utf_add_listing_part_headline_part">
        <h3 id="blog-faq-fields-heading">
          <i className="sl sl-icon-question"></i> FAQ
        </h3>
        <p>Add only questions that are answered on the public article.</p>
      </div>

      {faqs.map((faq, index) => (
        <div className="blog-faq-field" key={faq.id || `faq-${index}`}>
          <div className="blog-faq-field__header">
            <strong>Question {index + 1}</strong>
            <div className="blog-faq-field__actions">
              <button type="button" className="btn btn-secondary btn-sm" onClick={() => moveFaq(index, -1)} disabled={index === 0} aria-label={`Move question ${index + 1} up`}>↑</button>
              <button type="button" className="btn btn-secondary btn-sm" onClick={() => moveFaq(index, 1)} disabled={index === faqs.length - 1} aria-label={`Move question ${index + 1} down`}>↓</button>
              <button type="button" className="btn btn-red btn-sm" onClick={() => updateFaqs(faqs.filter((_, faqIndex) => faqIndex !== index))}>Remove</button>
            </div>
          </div>
          <label htmlFor={`blog-faq-question-${index}`}>Question</label>
          <input
            id={`blog-faq-question-${index}`}
            className="form-input"
            type="text"
            value={faq.question || ""}
            onChange={(event) => updateFaq(index, "question", event.target.value)}
            placeholder="Enter a customer question"
          />
          <label htmlFor={`blog-faq-answer-${index}`}>Answer</label>
          <textarea
            id={`blog-faq-answer-${index}`}
            className="form-input"
            rows="4"
            value={faq.answer || ""}
            onChange={(event) => updateFaq(index, "answer", event.target.value)}
            placeholder="Write a clear, complete answer"
          />
        </div>
      ))}

      <button
        type="button"
        className="button add-pricing-list-item"
        onClick={() => updateFaqs([...faqs, { question: "", answer: "" }])}
      >
        Add question
      </button>
    </section>
  );
};

export default BlogFaqFields;
